import { ISO } from './countryIsoCodes';

/**
 * Wikidata Q codes for countries (ISO 3166-1 alpha-3).
 * Used for schema.org sameAs and other structured data linking to Wikidata.
 * @see https://www.wikidata.org/wiki/Wikidata:List_of_properties/Place
 */
export const COUNTRY_ISO_TO_WIKIDATA_Q: Partial<Record<ISO, string>> = {
  [ISO.GBR]: 'Q145',
  [ISO.AUS]: 'Q408',
  [ISO.AUT]: 'Q40',
  [ISO.BEL]: 'Q31',
  [ISO.CAN]: 'Q16',
  [ISO.CZE]: 'Q213',
  [ISO.DNK]: 'Q35',
  [ISO.FRA]: 'Q142',
  [ISO.DEU]: 'Q183',
  [ISO.IRL]: 'Q27',
  [ISO.ITA]: 'Q38',
  [ISO.JPN]: 'Q17',
  [ISO.NOR]: 'Q20',
  [ISO.POL]: 'Q36',
  [ISO.PRT]: 'Q45',
  [ISO.ESP]: 'Q29',
  [ISO.SWE]: 'Q34',
  [ISO.CHE]: 'Q39',
  [ISO.NLD]: 'Q55',
  [ISO.NZL]: 'Q664',
  [ISO.USA]: 'Q30',
};

/** Default fallback when country has no mapping (United Kingdom). */
export const DEFAULT_WIKIDATA_Q = 'Q145';

/**
 * Returns the Wikidata Q code for a country ISO 3166-1 alpha-3 code.
 * @param iso - Country ISO code (e.g. ISO.ESP, ISO.USA)
 * @param fallback - Optional fallback Q code when no mapping exists (default: Q145 / UK)
 */
export function getWikidataQByCountryIso(
  iso: ISO,
  fallback: string = DEFAULT_WIKIDATA_Q,
): string {
  return COUNTRY_ISO_TO_WIKIDATA_Q[iso] ?? fallback;
}

/**
 * Returns the full Wikidata URL for a country ISO 3166-1 alpha-3 code.
 * @param iso - Country ISO code (e.g. ISO.ESP, ISO.USA)
 * @param fallback - Optional fallback Q code when no mapping exists (default: Q145 / UK)
 */
export function getWikidataUrlByCountryIso(
  iso: ISO,
  fallback: string = DEFAULT_WIKIDATA_Q,
): string {
  const q = getWikidataQByCountryIso(iso, fallback);
  return `https://www.wikidata.org/wiki/${q}`;
}
